import '../fonts/Outfit-Regular.woff2';
import '../fonts/Outfit-Medium.woff2';
import '../fonts/Outfit-SemiBold.woff2';

import 'aos/dist/aos.css';
import '../sass/main.scss';

import AOS from 'aos';
import Rellax from 'rellax';

import './common/custom-select.js';
import './common/focus.js';
import './common/screen-width.js';
import './common/screen-height.js';
import './common/css-variables.js';

import './layouts/cookies-notice.js';
import './layouts/site-header.js';
import './layouts/site-menu-modal.js';
import './layouts/site-menu-bar.js';

import './common/on-screen.js';

import { initModals } from './common/modals.js';

import '../img/map.svg';
import '../img/icon-horizontal-scroller-white.svg';
import '../img/icon-horizontal-scroller-blue.svg';

const initScrollAnimations = () => {
    AOS.init({
        duration: 750
    });

    window.addEventListener('load', () => AOS.refresh(), { once: true });
};

(() => {
    initModals();
    initScrollAnimations();
})();
